import { getLocalDateTime } from '@sonar-software/sonar-ts-lib';
import React from 'react';
import { Row } from 'antd';
import { SonarText } from '@ui/text';
export const DateTimeColumn = ({ dateTime }) => {
    if (!dateTime) {
        return null;
    }
    const localMoment = getLocalDateTime(dateTime);
    const formattedDate = localMoment.format('ll');
    const formattedTime = localMoment.format('LT');
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(SonarText, null, formattedDate)),
        React.createElement(Row, null,
            React.createElement(SonarText, null, formattedTime))));
};
